if (!customElements.get('tabbed-images')) {
  customElements.define('tabbed-images', class extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.tabbed-images__tab');
      this.images = this.querySelectorAll('.tabbed-images__image');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick.bind(this));
      });
    }

    onTabClick(event) {
      const selectedTab = event.currentTarget;
      const selectedIndex = selectedTab.dataset.index;

      this.tabs.forEach((tab) => {
        if (tab.dataset.index === selectedIndex) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });

      this.images.forEach((image) => {
        if (image.dataset.index === selectedIndex) {
          image.classList.add('active');
        } else {
          image.classList.remove('active');
        }
      });
    }
  });
}